import type { FC } from 'react';
import type { PickProps } from '@/ui/types/types';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import styles from './TextArea.module.css';

type Props = {
    block?: boolean;
    error?: boolean;
} & PickProps<'textarea', 'placeholder'
| 'value'
| 'rows'
| 'cols'
| 'onChange'
| 'onInput'
| 'onFocus'
| 'onBlur'
| 'name'
| 'disabled'>;

export const TextArea: FC<Props> = ({ block, error, ...props }) => (
    <motion.textarea
        initial={{ scale: 1 }}
        whileFocus={{ scale: 0.992 }}
        transition={{ duration: 0.1 }}
        className={clsx(styles.textArea, block && styles.block, error && styles.error)}
        {...props}
    />
);
